module.exports = __webpack_public_path__ + "img/sticon.6387147.png";